<template>
    <v-simple-table class="v-data-table--no-hover">
        <thead>
            <tr>
                <th>구분</th>
                <th>성함</th>
                <th>세부내용</th>
            </tr>
        </thead>
        <tbody>
            <template v-for="supporter in supporters">
                <tr v-for="(item, index) in supporter.list" :key="index">
                    <th v-if="index === 0" :rowspan="supporter.list.length">{{ supporter.position }}</th>
                    <td>{{ item.name }}</td>
                    <td>
                        <div v-for="text in item.detail" :key="text">{{ text }}</div>
                    </td>
                </tr>
            </template>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    data() {
        return {
            supporters: [
                {
                    position: "후원회장",
                    list: [
                        {
                            name: "박순호",
                            detail: ["용인대학교 체육과학대학", "스포츠레저학과 명예교수"],
                        },
                    ],
                },
                {
                    position: "부회장",
                    list: [
                        {
                            name: "신승근",
                            detail: ["㈜ 레빗츠원 대표", "영화제작자 및 감독"],
                        },
                    ],
                },
                {
                    position: "위원",
                    list: [
                        {
                            name: "김경희",
                            detail: ["원천인터내셔널 대표"],
                        },
                        {
                            name: "이문원",
                            detail: ["이문원한의원 대표원장"],
                        },
                        {
                            name: "허은화",
                            detail: ["㈜파이어택 대표"],
                        },
                        {
                            name: "김선미",
                            detail: ["㈜조은비앤에프 대표"],
                        },
                        {
                            name: "류용봉",
                            detail: ["㈜모든 비즈니스솔루션 대표"],
                        },
                        {
                            name: "박진성",
                            detail: ["목동 우보한의원 원장"],
                        },
                        {
                            name: "송성원",
                            detail: ["㈜더마크월드 대표"],
                        },
                        {
                            name: "김영준",
                            detail: ["㈜파이어택 이사"],
                        },
                        {
                            name: "장혜순",
                            detail: ["㈜아토아트 회장"],
                        },
                        {
                            name: "송연미",
                            detail: ["와이드코칭 대표"],
                        },
                        {
                            name: "이문재",
                            detail: ["㈜한울 대표"],
                        },
                        {
                            name: "하승범",
                            detail: ["㈜위드아띠 대표"],
                        },
                        {
                            name: "박정훈",
                            detail: ["세이브힐즈 대표"],
                        },
                        {
                            name: "최정영",
                            detail: ["㈜미르아키틱 대표"],
                        },
                        {
                            name: "연현주",
                            detail: ["청연 원장"],
                        },
                        {
                            name: "조부경",
                            detail: ["더성장연구소 원장"],
                        },
                        {
                            name: "조영관",
                            detail: ["법무법인 덕수 파트너 변호사"],
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.v-data-table {
    border-top: 1px solid #111;
    border-bottom: 1px solid #111;
    border-radius: 0;
    thead {
        tr {
            th {
                color: #111 !important;
            }
        }
    }
    tbody {
        tr {
            th {
                color: #666 !important;
            }
        }
    }
    th,
    td {
        border-right: 1px solid #ddd;
        text-align: center !important;
        font-size: 14px !important;
        word-break: keep-all;
    }
    th {
        background-color: #f5f5f5;
        font-weight: 400;
    }
    td {
        color: #666 !important;
        > span,
        > strong {
            color: var(--v-primary-base);
        }
    }
}
</style>
